var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _rect, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHpLayoutz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 121,
    viewBox: "0 0 136 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.159 86.5068V8.41736C117.159 3.76675 113.304 -0.00341797 108.549 -0.00341797C103.245 -0.00341797 98.9451 4.20229 98.9451 9.39019V94.9275H125.768C121.013 94.9275 117.159 91.1574 117.159 86.5068Z",
    fill: "#BE2B6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8378 10.2384V120.585H91.7905C96.3354 120.585 100.02 116.941 100.02 112.446V9.37779C100.02 4.19674 104.267 -0.00341797 109.506 -0.00341797H29.1938C23.4744 -0.00341797 18.8378 4.58195 18.8378 10.2384Z",
    fill: "#FFFFFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.024 29.2192C135.024 28.667 134.576 28.2192 134.024 28.2192H117.034V86.642C117.034 91.2179 120.841 94.9275 125.537 94.9275C130.62 94.9275 134.76 91.0533 135.024 86.178V29.2192Z",
    fill: "#97144D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.4538 98.4932C81.4538 97.9409 81.006 97.4932 80.4538 97.4932H1.74902C1.19674 97.4932 0.749023 97.9409 0.749023 98.4932V112.53C0.749023 116.979 4.5563 120.584 9.25269 120.584H89.9574C85.261 120.584 81.4538 116.979 81.4538 112.53V98.4932Z",
    fill: "#BE2B6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2483 23.5266C43.2483 23.6647 43.3602 23.7766 43.4983 23.7766H85.7198C85.8579 23.7766 85.9698 23.6647 85.9698 23.5266V19.1655C85.9698 19.0275 85.8579 18.9155 85.7198 18.9155H43.4983C43.3602 18.9155 43.2483 19.0275 43.2483 19.1655V23.5266Z",
    fill: "#DEDED9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2483 45.4016C43.2483 45.5397 43.3602 45.6516 43.4983 45.6516H85.7198C85.8579 45.6516 85.9698 45.5397 85.9698 45.4016V41.0405C85.9698 40.9025 85.8579 40.7905 85.7198 40.7905H43.4983C43.3602 40.7905 43.2483 40.9025 43.2483 41.0405V45.4016Z",
    fill: "#DEDED9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2483 67.2766C43.2483 67.4147 43.3602 67.5266 43.4983 67.5266H85.7198C85.8579 67.5266 85.9698 67.4147 85.9698 67.2766V62.9155C85.9698 62.7775 85.8579 62.6655 85.7198 62.6655H43.4983C43.3602 62.6655 43.2483 62.7775 43.2483 62.9155V67.2766Z",
    fill: "#DEDED9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2483 91.5823C43.2483 91.7204 43.3602 91.8323 43.4983 91.8323H85.7198C85.8579 91.8323 85.9698 91.7204 85.9698 91.5823V87.2212C85.9698 87.0831 85.8579 86.9712 85.7198 86.9712H43.4983C43.3602 86.9712 43.2483 87.0831 43.2483 87.2212V91.5823Z",
    fill: "#DEDED9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2483 16.2349C43.2483 16.373 43.3602 16.4849 43.4983 16.4849H66.7325C66.8705 16.4849 66.9825 16.373 66.9825 16.2349V11.8738C66.9825 11.7357 66.8705 11.6238 66.7325 11.6238H43.4983C43.3602 11.6238 43.2483 11.7357 43.2483 11.8738V16.2349Z",
    fill: "#DEDED9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2483 38.1099C43.2483 38.248 43.3602 38.3599 43.4983 38.3599H66.7325C66.8705 38.3599 66.9825 38.248 66.9825 38.1099V33.7488C66.9825 33.6107 66.8705 33.4988 66.7325 33.4988H43.4983C43.3602 33.4988 43.2483 33.6107 43.2483 33.7488V38.1099Z",
    fill: "#DEDED9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2483 59.9849C43.2483 60.123 43.3602 60.2349 43.4983 60.2349H66.7325C66.8705 60.2349 66.9825 60.123 66.9825 59.9849V55.6238C66.9825 55.4857 66.8705 55.3738 66.7325 55.3738H43.4983C43.3602 55.3738 43.2483 55.4857 43.2483 55.6238V59.9849Z",
    fill: "#DEDED9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2483 84.2906C43.2483 84.4286 43.3602 84.5406 43.4983 84.5406H66.7325C66.8705 84.5406 66.9825 84.4286 66.9825 84.2906V79.9294C66.9825 79.7914 66.8705 79.6794 66.7325 79.6794H43.4983C43.3602 79.6794 43.2483 79.7914 43.2483 79.9294V84.2906Z",
    fill: "#DEDED9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.6344,
    y: 11.6238,
    width: 11.8671,
    height: 12.1528,
    rx: 1,
    fill: "#97144D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2246 13.325C32.0866 13.325 31.9746 13.4369 31.9746 13.575V17.6586L31.9665 17.6727C31.9175 17.7577 31.9239 17.8594 31.9746 17.936V17.9361C31.9746 18.0741 32.0866 18.1861 32.2246 18.1861H32.3557L36.8873 20.8024C37.0069 20.8715 37.1598 20.8305 37.2288 20.7109L37.5722 20.1162C37.6412 19.9966 37.6003 19.8438 37.4807 19.7747L33.1614 17.281V13.575C33.1614 13.4369 33.0494 13.325 32.9114 13.325H32.2246Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6344 33.7695C26.6344 33.2172 27.0821 32.7695 27.6344 32.7695H37.5015C38.0538 32.7695 38.5015 33.2172 38.5015 33.7695V43.9223C38.5015 44.4746 38.0538 44.9223 37.5015 44.9223H27.6344C27.0821 44.9223 26.6344 44.4746 26.6344 43.9223V33.7695Z",
    fill: "#97144D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1456 35.6226C30.0249 35.6896 29.9812 35.8417 30.0482 35.9625L31.7709 39.0704L28.0173 41.899C27.907 41.9821 27.885 42.1388 27.9681 42.2491L28.3814 42.7975C28.4644 42.9078 28.6212 42.9298 28.7315 42.8467L33.185 39.4908C33.2952 39.4077 33.3173 39.2509 33.2342 39.1407L32.979 38.802L31.0861 35.3871C31.0192 35.2664 30.867 35.2228 30.7462 35.2897L30.1456 35.6226Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6344 55.6445C26.6344 55.0922 27.0821 54.6445 27.6344 54.6445H37.5015C38.0538 54.6445 38.5015 55.0922 38.5015 55.6445V65.7973C38.5015 66.3496 38.0538 66.7973 37.5015 66.7973H27.6344C27.0821 66.7973 26.6344 66.3496 26.6344 65.7973V55.6445Z",
    fill: "#97144D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6362 61.8373C32.7243 61.8715 32.8281 61.854 32.9006 61.7841L32.9721 61.715L33.3268 61.5859C33.4565 61.5387 33.5234 61.3952 33.4762 61.2655L33.4661 61.2379L36.9119 57.9104C37.0112 57.8145 37.014 57.6562 36.9181 57.5569L36.441 57.0629C36.3451 56.9636 36.1868 56.9608 36.0875 57.0567L32.3292 60.6861L28.8228 61.9624C28.693 62.0096 28.6261 62.153 28.6733 62.2828L28.9082 62.9281C28.9554 63.0578 29.0989 63.1247 29.2286 63.0775L32.6362 61.8373Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6344 79.9502C26.6344 79.3979 27.0821 78.9502 27.6344 78.9502H37.5015C38.0538 78.9502 38.5015 79.3979 38.5015 79.9502V90.103C38.5015 90.6553 38.0538 91.103 37.5015 91.103H27.6344C27.0821 91.103 26.6344 90.6553 26.6344 90.103V79.9502Z",
    fill: "#97144D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8272 82.0984C29.7155 82.1795 29.6907 82.3359 29.7719 82.4476L31.8869 85.3586L32.0589 85.888C32.1015 86.0193 32.2426 86.0912 32.3739 86.0485L32.4024 86.0392C32.4865 86.0933 32.5987 86.0934 32.6845 86.0311L32.8925 85.88L37.6774 84.3253C37.8087 84.2826 37.8805 84.1416 37.8379 84.0103L37.6257 83.3572C37.583 83.2259 37.442 83.154 37.3106 83.1967L32.8387 84.6497L30.732 81.75C30.6508 81.6383 30.4945 81.6136 30.3828 81.6947L29.8272 82.0984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpLayoutz);
export default __webpack_public_path__ + "static/media/hp-layoutz.1773eca84a7fc4c27fbd50d0bfd378c1.svg";
export { ForwardRef as ReactComponent };